import * as Sentry from "@sentry/browser";

Sentry.init({
    dsn: process.env.SENTRY_DSN,

    // removing Google Translate plugin from error logs
    denyUrls: [
        'https://translate.google.com/translate_a/element.js',
        /https?:\/\/translate\.googleapis\.com/i,
    ],

    // Alternatively, use `process.env.npm_package_version` for a dynamic release version
    // if your build tool supports it.
    release: process.env.SENTRY_RELEASE,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    tracesSampleRate: process.env.SENTRY_TRACES_SAMPLE_RATE,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: process.env.SENTRY_SESSION_SAMPLE_RATE,
    replaysOnErrorSampleRate: 1.0,
    debug: true
});